import { BreadcrumbGroupProps } from '@amzn/awsui-components-react/polaris/breadcrumb-group';
import { i18nStrings } from 'utils/constants';

export const WORKSHOP_PATH = 'workshop';
export const EVENT_RUNTIME_STATE_ORDER = [
    'scheduled',
    'canceled',
    'not_started',
    'start_in_progress',
    'start_failed',
    'start_success',
    'pause_in_progress',
    'pause_failed',
    'pause_success',
    'terminate_in_progress',
    'terminate_failed',
    'terminate_success',
];
export const BASE_BREADCRUMBS: BreadcrumbGroupProps.Item[] = [
    {
        text: i18nStrings.event.headers.dashboard,
        href: '/',
    },
];
export const NOTIFICATION_THRESHOLDS_MINUTES = [5, 15, 60];
export const EVENT_DURATION_INTERVAL = 60000;
export const MAX_CONSECUTIVE_ERROR_THRESHOLD = 5;
